import { IconRefresh, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import DateRange from '../../components/DateRange/DateRange';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { accessKeys } from '../../statics/accessKeys';
import { accessCheck } from '../../utils/accessCheck';
import { dateIntoYYYY_MM_DD } from '../../utils/dateTimeConverter';
import GoogleAdsCampaignsTab from './Components/GoogleAdsCampaignsTab';
import GoogleAdsGroupTab from './Components/GoogleAdsGroupTab';
import GoogleAdsTab from './Components/GoogleAdsTab';
import GoogleAdsPlatformGraph from './Components/GoogleAdsPlatformGraph';
import StatsCard from "../../components/StatsCard/StatsCard";
import { PROFILE, SELECTED_GOOGLE_ACCOUNT } from '../../statics/localStorage';
import RequestPlan from '../../components/Plan/RequestPlan';
import GoogleAccountsModal from './Components/GoogleAccountsModal';
import GoogleManagerAccountModal from './Components/GoogleManagerAccountModal';

const GoogleAnalytics = () => {
    const profileData = PROFILE();
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [cardData, setCardData] = useState(null);
    const [selectedTab, setSelectedTab] = useState(1);

    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [selectedAdSet, setSelectedAdSet] = useState(null);
    const [selectedGoogleAccount, setSelectedGoogleAccount] = useState(SELECTED_GOOGLE_ACCOUNT())

    async function getCardsData() {
        loadingShow();
        let postData = {
            googleAdsClientId: selectedGoogleAccount?.googleAdsClientId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getGoogleAdsCardData}`;
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            setCardData(resp.data);
        } else {
            setCardData(null);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewMetaAnalytics) && profileData?.planRequestStatus == 3) {
            getCardsData();
        }
    }, [date, selectedGoogleAccount]);

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        // setActivePage(1);
        setDate(newDate)
    }

    async function syncAdsCampaign() {
        if (!selectedGoogleAccount?.googleAdsClientId) {
            toast.error("Please select an Google account from the Accounts Popup.");
            return
        }
        loadingShow();
        let postData = {
            "googleAdsClientId": selectedGoogleAccount?.googleAdsClientId
        }
        let url = `${urlApi.syncGoogleAdsCampaign}`;
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            setSelectedTab(1);
            setSelectedCampaign(null);
            setSelectedAdSet(null);
            setDate({ startDate: '', endDate: '' })
        } else {
            toast.error(resp.message);
        }
    }

    const handleClearAdSet = (e) => {
        e.stopPropagation();
        setSelectedCampaign(null);
        setSelectedAdSet(null);
    }

    if (profileData?.planRequestStatus != 3) {
        return (
            <Layout>
                <RequestPlan profileData={profileData} />
            </Layout>
        )
    }

    return (
        <Layout>

            <div className='flex mb-3 gap-3 flex-wrap items-center'>
                <div className='px-2'>
                    <div className='flex gap-2 mb-1'>
                        <p className='text-[17px] font-bold mb-0 text-[var(--grey)]'>Google Ads</p>
                        <GoogleAccountsModal setSelectedGoogleAccount={setSelectedGoogleAccount} />
                        <GoogleManagerAccountModal />
                    </div>

                    <p className='text-sm'>[ {selectedGoogleAccount?.accountName} {selectedGoogleAccount?.accountName && "-"} {selectedGoogleAccount?.googleAdsClientId} ]</p>
                </div>
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />

                {accessCheck(accessKeys?.syncGoogleAds) && <IconButton text={"Sync Ads"} icon={<IconRefresh size={20} />} onClickFunction={() => syncAdsCampaign()} />}
            </div>

            <div className="mb-3">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                    <div className="col-span-1 md:col-span-2">
                        <StatsCard title={"Total Amount Invested"} value={cardData?.totalSpend?.toFixed(2) || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Interactions"} value={cardData?.totalInteractions || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Clicks"} value={cardData?.totalClicks || 0} />
                    </div>
                    <div className="col-span-1">
                        <StatsCard title={"Conversion"} value={cardData?.totalConversion || 0} />
                    </div>
                    {/* <div className="col-span-1">
                        <StatsCard title={"Registrations"} value={cardData?.totalRegistrations || 0} />
                    </div> */}
                </div>
            </div>

            <div className="mb-3">
                <GoogleAdsPlatformGraph date={date} selectedGoogleAccount={selectedGoogleAccount} />
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                <div className="col-span-1">
                    <StatsCard title={"Reach"} value={cardData?.totalReach || 0} />
                </div>
                <div className="col-span-1">
                    <StatsCard title={"Cost/Installation"} value={cardData?.costPerInstall || 0} />
                </div>
                <div className="col-span-1">
                    <StatsCard title={"Cost/Registration"} value={cardData?.costPerRegistration || 0} />
                </div>
            </div> */}

            <div className="flex items-center flex-wrap justify-center gap-3 px-2 py-1 bg-white rounded-lg max-w-fit mx-auto mb-3">
                <button onClick={() => { setSelectedTab(1) }} className={`${selectedTab == 1 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`} >Campaigns</button>

                <button onClick={() => { setSelectedTab(2) }} className={`${selectedTab == 2 ? '!bg-primary text-white' : 'bg-transparent'} flex items-center gap-2 text-sm font-semibold px-5 py-1 rounded-lg`}>Ad Group
                    {selectedCampaign && <p className={`bg-primary text-white h-5 flex px-2 items-center justify-center text-[10px] rounded-full mb-0`} >1 Selected
                        <button className='border-1 border-white rounded-full ms-2' onClick={handleClearAdSet}><IconX size={14} /></button>
                    </p>}
                </button>

                <button onClick={() => { setSelectedTab(3) }} className={`${selectedTab == 3 ? '!bg-primary text-white' : 'bg-transparent'} flex items-center gap-2 text-sm font-semibold px-5 py-1 rounded-lg`}>Ads
                    {selectedAdSet && <p className={`bg-primary text-white h-5 flex px-2 items-center justify-center text-xs rounded-full mb-0`} >1 Selected
                        <button className='border-1 border-white rounded-full ms-2' onClick={handleClearAdSet}><IconX size={14} /></button>
                    </p>}
                </button>
            </div>

            {selectedTab === 1 && <GoogleAdsCampaignsTab date={date} selectedCampaign={selectedCampaign} setSelectedCampaign={setSelectedCampaign} selectedGoogleAccount={selectedGoogleAccount} setSelectedTab={setSelectedTab} />}
            {selectedTab === 2 && <GoogleAdsGroupTab date={date} selectedCampaign={selectedCampaign} setSelectedAdSet={setSelectedAdSet} selectedGoogleAccount={selectedGoogleAccount} setSelectedTab={setSelectedTab} selectedAdSet={selectedAdSet} />}
            {selectedTab === 3 && <GoogleAdsTab date={date} selectedAdSet={selectedAdSet} selectedGoogleAccount={selectedGoogleAccount} />}

        </Layout>
    )
}

export default GoogleAnalytics